// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"90e2fe10","510":"4ef0c5a1","581":"da29c976"}[chunkId] + ".chunk.js";
};